import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { Input } from '../ui/input';
import { api } from '../../lib/api';
import { Search as SearchIcon } from 'lucide-react';

export default function FollowListSheet({ open, onOpenChange, username, kind }) {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !username) return;
    setLoading(true);
    api.get(`/users/${username}/${kind}?q=${encodeURIComponent(q)}`)
      .then(r => setItems(r.data))
      .finally(() => setLoading(false));
  }, [open, username, kind, q]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-[86%] max-w-md glass border-white/10 flex flex-col p-4">
        <SheetHeader>
          <SheetTitle className="font-display capitalize" data-testid={`follow-sheet-${kind}-title`}>{kind}</SheetTitle>
        </SheetHeader>
        <div className="relative mt-3">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <Input data-testid={`follow-sheet-search-${kind}`} value={q} onChange={e => setQ(e.target.value)} placeholder={`Search ${kind}`} className="pl-9" />
        </div>
        <div className="mt-3 flex-1 overflow-y-auto space-y-2 min-h-0">
          {loading && <div className="text-xs text-slate-400 py-6 text-center">Loading…</div>}
          {!loading && items.length === 0 && <div className="text-xs text-slate-400 py-6 text-center">No {kind} yet</div>}
          {items.map(u => {
            const initials = (u.display_name || u.username || 'JX').slice(0, 2).toUpperCase();
            return (
              <Link key={u.id} to={`/profile/${u.username}`} onClick={() => onOpenChange(false)}
                    data-testid={`${kind}-row-${u.username}`}
                    className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-white/5">
                <Avatar className="w-10 h-10"><AvatarImage src={u.avatar_url} /><AvatarFallback className="gradient-brand text-white font-bold">{initials}</AvatarFallback></Avatar>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{u.display_name || u.username}</div>
                  <div className="text-xs text-slate-400">@{u.username}</div>
                </div>
              </Link>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
}
